import { useStore } from 'effector-react'
import React, { useEffect } from 'react'
import { $assessment, assessmentMounted, getAssessment } from './model'

export const useAIAssessment = () => {
  const assessment = useStore($assessment)
  const loading = useStore(getAssessment.pending)

  useEffect(() => {
    assessmentMounted()
  }, [])

  return { assessment, loading }
}
